import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { HttpStatus, Redirect } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// types
import { AvailableLanguages } from '../../types/types'

// pats
import Paths from '../paths'

const SalonsCategoryDeprecatedRoute = () => {
	const { locale } = useIntl() as { locale: AvailableLanguages }
	const { search } = useLocation()
	const { categorySlug } = useParams()

	return (
		<HttpStatus status={301}>
			<Redirect to={`${Paths[locale]['/salons/all']}${categorySlug}${search}`} />
		</HttpStatus>
	)
}

export default SalonsCategoryDeprecatedRoute
